
namespace GeniuzPOS.SalePromoCamp {

    @Serenity.Decorators.registerClass()
    export class LookupItemCodeDialog extends Serenity.EntityDialog<LookupItemCodeRow, any> {
        protected getFormKey() { return LookupItemCodeForm.formKey; }
        protected getIdProperty() { return LookupItemCodeRow.idProperty; }
        protected getLocalTextPrefix() { return LookupItemCodeRow.localTextPrefix; }
        protected getNameProperty() { return LookupItemCodeRow.nameProperty; }
        protected getService() { return LookupItemCodeService.baseUrl; }
        protected getDeletePermission() { return LookupItemCodeRow.deletePermission; }
        protected getInsertPermission() { return LookupItemCodeRow.insertPermission; }
        protected getUpdatePermission() { return LookupItemCodeRow.updatePermission; }

        protected form = new LookupItemCodeForm(this.idPrefix);

    }
}